export default __webpack_public_path__ + "static/media/privacy-certified-globe-color-ubiosoft_110500.a5bd9310.jpg";